const UnknownCode = 'UNKNOWN';

const checkIsTourBookingAttempted = (tourItinerary, bookingResponses) => {
  const bookingResponse = bookingResponses.find(
    (response) => response.tripSegmentId === tourItinerary.tripSegmentId,
  );
  if (!bookingResponse) {
    return false;
  }

  const code = (bookingResponse.bookingStatusCode || '').toString().toUpperCase();
  const isAttempted = !!(bookingResponse.bookingReference || '').trim() || code === UnknownCode;
  return isAttempted;
};

const getToursToBook = (trip, tripConfirmation) => {
  const bookingResponses = (tripConfirmation && tripConfirmation.bookingResponses) || [];
  const toursToBook = ((trip && trip.tourItineraries) || []).filter(
    (tourItinerary) => !checkIsTourBookingAttempted(tourItinerary, bookingResponses),
  );
  return toursToBook;
};

export default getToursToBook;
